// extracted by mini-css-extract-plugin
export default {"root":"CustomEmpty_root__g2pAB"};